import http from '@/utils/http'
import Api from '@/conf/Api';
import notify from '@/utils/notify'

export function LOAD_JOBS({ commit }, data) {
  commit('SET_JOBS', []);
  return http.post(Api.supporter.dashboard.jobs, data)
    .then((res) => {
      commit('SET_JOBS', res.data);
      return res
    }).catch((e) => {
      notify(commit, e)
      return e
    })
}
export function LOAD_JOBS_DIFF({ commit }, data) {
  return http.post(Api.supporter.dashboard.jobs, data)
    .then((res) => {
      commit('SET_JOBS', res.data);
      return res
    }).catch((e) => {
      notify(commit, e)
      return e
    })
}
export function LOAD_ATTENDANCE({ commit }, data) {
  return http.post(Api.attendance, data)
    .then((res) => {
      commit('SET_JOBS', res.data);
      return res
    }).catch((e) => {
      commit('SET_JOBS', []);
      notify(commit, e)
      return e
    })
}

export function LOAD_APPLY({ commit }) {
  commit('SET_JOBS', []);
  return http.post(Api.supporter.apply, { ordenado_por: 'agendamento', ordem: 'decrescente' }).then((r) => {
    commit('SET_JOBS', r.data);
    return r.data
  }).catch((e) => {
    notify(commit, e)
  })
}

export function LOAD_AVAILABLE({ commit }) {
  commit('SET_AVAILABLE', []);
  return http.get(Api.supporter.available, {}).then((r) => {
    commit('SET_AVAILABLE', r.data);
  }).catch((e) => {
    notify(commit, e)
  })
}
